export default "__VITE_ASSET__5e4ffc73__"